module.exports = __webpack_public_path__ + "media/A1.96ab7d47.mp3";